export enum CoinFlip {
  Heads = -1,
  Tails = 1,
}

export class CoinFlipper {
  public flip(): CoinFlip {
    return Math.random() < 0.5 ? CoinFlip.Heads : CoinFlip.Tails;
  }

  public flips(noOfFlips): CoinFlip[] {
    const flips = new Array(noOfFlips).fill(Number.MAX_SAFE_INTEGER);

    return flips.map(this.flip);
  }
}
